import { IconButton, Modal, Paper, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export function DocumentDialog({ open, handleClose, documentUrl, downloadUrl }) {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <Paper sx={style}>
        <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ paddingRight: '20px', paddingTop: '10px' }}>
          <IconButton edge="start" color="inherit" aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Stack>

        <iframe style={{ width: '100%', height: '100%', border: 'none' }} title="Privacy" src={documentUrl}></iframe>
      </Paper>
    </Modal>
  );
}
